export const PASSWORD_REQUIREMENTS_TEXT =
  "At least 8 characters, with one uppercase letter, one lowercase letter, and one symbol.";

// Returns null if the password meets requirements, or an error message string.
export function validatePassword(password) {
  if (!password || password.length < 8) {
    return "Password must be at least 8 characters long.";
  }
  if (!/[A-Z]/.test(password)) {
    return "Password must contain at least one uppercase letter.";
  }
  if (!/[a-z]/.test(password)) {
    return "Password must contain at least one lowercase letter.";
  }
  if (!/[^A-Za-z0-9]/.test(password)) {
    return "Password must contain at least one symbol.";
  }
  return null;
}
